import React, { useCallback, useState } from 'react';
import { GET_ACTIVE_RECEIVED_REFERRALS } from '../gql';
import ActiveReceivedReferralsTable from '../tables/ActiveReceivedReferralsTable';
import { usePromoteReferral } from '../../referral/redux/promoteReferral';
import { REFERRAL_RECEIVER_SUBSCRIPTION } from '../../referral/gql/Subscription';
import UpdateReferrerClinicDialog from '../dialogs/UpdateReferrerClinicDialog';
import ActiveReferrals from './common/ActiveReferrals';
import ActiveReferralBaseDialogs from './common/ActiveReferralBaseDialogs';
import useActiveReferralDialogState from './common/useActiveReferralDialogState';

export default function ActiveReceivedReferrals({ history, uuid }) {
  const { promoteReferral } = usePromoteReferral();

  const [openReferrerClinicDialog, setOpenReferrerClinicDialog] = useState(false);
  const [selectedReferrerClinicReferral, setSelectedReferrerClinicReferral] = useState(null);

  const dialogs = useActiveReferralDialogState({
    promoteReferral,
    promoteStatus: 'rec_completed',
    successText: (data) =>
      data === 'Referral Completed'
        ? 'This referral has been moved to your Declined tab'
        : 'Referral Completed',
  });
  const {
    actionLoading,
    openNotesFor,
    openReferralEditor,
    openSentDateEditor,
    openAppointmentFor,
    handleOnComplete,
    setRefresh,
  } = dialogs;

  const handleUpdateReferrerClinic = useCallback((item) => {
    setSelectedReferrerClinicReferral(item);
    setOpenReferrerClinicDialog(true);
  }, []);

  const buildActions = useCallback(
    (item) => ({
      onViewNotes: () => openNotesFor(item.id),
      onReview: () => history.push(`/referrals/${item.id}/review`),
      onComplete: () => handleOnComplete(item),
      onSetAppointment: () =>
        openAppointmentFor({
          id: item.id,
          appointment: item?.appointment,
          nextStatus: item.status,
        }),
      onUpdateReferral: () => openReferralEditor(item),
      onUpdateSentDate: () => openSentDateEditor(item),
      onUpdateReferrerClinic: () => handleUpdateReferrerClinic(item),
    }),
    [handleOnComplete, handleUpdateReferrerClinic, history, openAppointmentFor, openNotesFor, openReferralEditor, openSentDateEditor]
  );

  return (
    <ActiveReferrals
      query={GET_ACTIVE_RECEIVED_REFERRALS}
      uuid={uuid}
      subscription={REFERRAL_RECEIVER_SUBSCRIPTION}
      tableComponent={ActiveReceivedReferralsTable}
      buildActions={buildActions}
      tableProps={{ onSelectedRowsChanged: () => {} }}
      isBusy={actionLoading}
      subscriptionClinicIdFallback={-1}
      shouldShowGlobalLoader={({ isBusy: busy }) => busy}
      renderDialogs={({ refresh }) => {
        setRefresh(refresh);
        return (
          <>
            <ActiveReferralBaseDialogs history={history} dialogs={dialogs} isReceived={true} />

            <UpdateReferrerClinicDialog
              open={openReferrerClinicDialog}
              onClose={() => {
                setOpenReferrerClinicDialog(false);
                refresh();
              }}
              referral={selectedReferrerClinicReferral}
            />
          </>
        );
      }}
    />
  );
}
